import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import type {
	NotificationPreferenceResponse,
	UpdateNotificationPreferenceRequest,
} from "./types"

export const getNotificationPreferences = async (
	apiClient: APIClient,
	signal?: AbortSignal,
): Promise<NotificationPreferenceResponse[]> =>
	(
		await apiClient.get<NotificationPreferenceResponse[]>(
			"/notification-preferences",
			{ signal },
		)
	).data

export const updateNotificationPreference = async (
	apiClient: APIClient,
	request: UpdateNotificationPreferenceRequest,
	signal?: AbortSignal,
): Promise<void> => {
	await apiClient.put("/notification-preferences", request, { signal })
}
